<template>
  <div class="vip_message__body" data-testid="vip-message">
    <i class="rhg-font-icon--coffee-tea-facilities sm mr-3"></i>
    <p v-html="vipLabel"></p>
  </div>
</template>

<script>
import { translate } from 'rhg-vue-common'

export default {
  name: 'VipMessageBreakfast',
  computed: {
    vipLabel() {
      return `${translate('boVipUpgrade', undefined, `<span style="font-weight: 100">${translate('boVipUpgradeForGuest')}</span>`)}`
    }
  }
}
</script>

<style lang="scss" scoped>
.vip_message {
  &__body {
    padding: 12px 36px 12px 36px;
    margin-bottom: 1.5rem;
    border-radius: 8px;
    background-color: #242424;
    color: #ffffff;
    font-size: 14px;
    display: flex;
    align-items: center;
    p {
      font-weight: 700;
      margin-bottom: 0;
    }
    @media (max-width: 992px) {
      margin-top: 1.5rem;
    }
    @media (max-width: 514px) {
      margin-left: 15px;
      margin-right: 15px;
      padding: 12px 24px 12px 24px;
      display: flex;
      align-items: flex-start;
    }
  }
}
</style>
